import * as React from 'react';
type Props = {
  className?: string;
};
export function Google({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Google"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.01576 11.5143V11.4943C2.30143 6.16626 6.7804 2 12.2082 2H12.1776C14.667 2 17.0749 2.88132 18.9522 4.48373H18.993C18.1666 5.41513 17.2891 6.30647 16.3709 7.14773C14.0753 5.55534 10.7798 5.12469 8.46384 6.9274H8.47404C5.60709 9.04058 5.02554 13.0466 7.1885 15.8608C7.48438 16.2414 7.83127 16.5919 8.19857 16.9024C11.2492 19.6465 17.1463 18.2744 18.0033 14.0581C16.0648 14.0581 14.1161 14.0581 12.1776 13.998C12.1776 12.8663 12.1776 11.7246 12.1776 10.5929C15.422 10.5929 18.6665 10.5929 21.9109 10.5929V10.623C22.2578 13.3571 21.5844 16.1212 20.0132 18.4046C17.5442 21.8098 12.4531 22.8313 8.48424 21.319L8.54546 21.339C4.4848 19.8168 1.86272 15.9209 2.00556 11.6445"
        fill="currentColor"
      />
    </svg>
  );
}
